import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7268c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "me-auto" }
const _hoisted_5 = {
  key: 0,
  class: "d-block icon mt-3"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "modal-header" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col-8 col-sm-6 col-md-5 col-lg-5 mb-3" }
const _hoisted_12 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal-container align-items-center mb-3",
        style: _normalizeStyle({ width: _ctx.width, height: _ctx.height })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createVNode(_component_AsahiTypography, {
                type: !_ctx.isMobile ? 'body-1-extrabold': 'title-1-extrabold'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.title)), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ], true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "d-flex btn-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
            "aria-label": "Close"
          })
        ]),
        (_ctx.icon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.icon,
                width: "32"
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createVNode(_component_AsahiTypography, {
              type: !_ctx.isMobile ? 'body-1-extrabold': 'title-1-extrabold'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.message)), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ], true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_AsahiTypography, { type: "title-2-regular" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.headerSubMsg)), 1)
            ]),
            _: 1
          }),
          (_ctx.hyperLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.hyperLink,
                target: "_self",
                color: "tertiary"
              }, _toDisplayString(_ctx.hyperLinkText), 9, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _createVNode(_component_AsahiTypography, { type: "body-2-extrabold" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.subMessage)), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.showButton)
                  ? (_openBlock(), _createBlock(_component_AsahiButton, {
                      key: 0,
                      type: "primary",
                      class: "w-100",
                      onClick: _ctx.close
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.buttonText)), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_AsahiTypography, { type: "subtitle" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.footerMessage)), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ], true)
        ])
      ], 4)
    ])
  ]))
}